import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation updateMessageMutation($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      message {
        ...MessageCell_message
      }
      errors {
        key
        messages
      }
    }
  }
`;

const updateMessage = (environment, attributes, args = {}) => {
  const {
    backgroundImage: messageBackgroundImage,
    ...otherAttributes
  } = attributes;

  const uploadables = messageBackgroundImage
    ? { messageBackgroundImage }
    : null;

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    ...args,
  });
};

export default updateMessage;
